import React, { useState } from "react";
import Logo from "../../../components/common/Brand";
import { useDispatch, useSelector } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";
//import { Link } from "react-router-dom";

import { Container, FormContainer, ImgSection } from "./LoginStyles";
import { login } from "../../../redux/slices/authSlice";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const toggleType = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <Container>
      <FormContainer>
        <a href="https://clickcircle.online" rel="noopener noreferrer">
          <Logo size={32} />
        </a>
        {/* <Logo size={32} /> */}
        <h1>Sign In</h1>
        <form onSubmit={handleSubmit}>
          <div className="single-form">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="single-form">
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {showPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType} />
            ) : (
              <FaEye className="eye" onClick={toggleType} />
            )}
          </div>
          <div className="forgot-password">
            <p></p>
            <a href="/forgot-password">Forgot password</a>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
        <p>
          Don’t have an account? <a href="/signup">Sign up</a>
        </p>
      </FormContainer>

      <ImgSection>
        <div>
          <Logo size={26} />
          <p>
            Run your ads and campaigns with ClickCircle and make huge <br />
            impressions and conversions that will help your business{" "}
          </p>
        </div>
      </ImgSection>
    </Container>
  );
};

export default Login;
